import React from 'react';
import { useTranslation } from 'react-i18next';

const DURATION_PRESETS = ['5 min', '10 min', '15 min', '30 min', '1 hora', '2 horas', '4 horas', '1 día', '1 semana'];

// slice 02.1 · paso b — presentacional. El popover de duración de una tarea (era el render
// helper `renderDurationPopover` de `ComponentTaskHoy`, usado en la fila de la lista y en el
// panel de detalle). `popoverRef` lo forwardea el contenedor para su handler de click-afuera.
export const DurationPopover = ({ popoverRef, customNum, customUnit, onCustomNumChange, onCustomUnitChange, onCustomSubmit, onPresetSelect }) => {
    const { t: translate } = useTranslation('tasks');

    return (
        <div
            className="task-row-dropdown time-dropdown"
            ref={popoverRef}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            style={{
                position: 'absolute',
                left: '0',
                top: '100%',
                background: '#232323',
                border: '1px solid #333',
                borderRadius: 'var(--radius-md)',
                padding: 'var(--space-2)',
                zIndex: 3000,
                width: '200px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.5)'
            }}
        >
            <form onSubmit={onCustomSubmit} style={{ display: 'flex', gap: '4px', marginBottom: 'var(--space-2)' }}>
                <input
                    type="number"
                    min="1"
                    placeholder="0"
                    aria-label={translate('duration.amountAria')}
                    style={{ width: '40px', background: '#333', border: 'none', color: '#fff', borderRadius: 'var(--radius-sm)', padding: 'var(--space-1)' }}
                    value={customNum}
                    onChange={(e) => onCustomNumChange(e.target.value)}
                />
                <select
                    aria-label={translate('duration.unitAria')}
                    style={{ flex: 1, background: '#333', border: 'none', color: '#fff', borderRadius: 'var(--radius-sm)', padding: 'var(--space-1)' }}
                    value={customUnit}
                    onChange={(e) => onCustomUnitChange(e.target.value)}
                >
                    <option value="minutos">{translate('duration.units.minutos')}</option>
                    <option value="horas">{translate('duration.units.horas')}</option>
                    <option value="días">{translate('duration.units.días')}</option>
                    <option value="semanas">{translate('duration.units.semanas')}</option>
                </select>
                <button type="submit" style={{ background: '#4ade80', color: '#000', border: 'none', borderRadius: 'var(--radius-sm)', padding: 'var(--space-1) var(--space-2)', cursor: 'pointer', fontWeight: 'bold' }}>✔</button>
            </form>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px' }}>
                {DURATION_PRESETS.map(preset => (
                    <button
                        key={preset}
                        type="button"
                        className="time-preset-btn"
                        onClick={() => onPresetSelect(preset)}
                    >
                        {preset}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default DurationPopover;
